<p-toast></p-toast>
<div class="grid p-fluid">
    <div class="col-12">
        <div class="card">
            <p-toolbar>
                <div class="p-toolbar-group-left">
                    <h3 class="m-0">SUREPARK Accounts List</h3>
                </div>
            </p-toolbar>
            <p-table #invoiceTable [value]="accounts" [resizableColumns]="true" responsiveLayout="scroll"
                [paginator]="true" [rows]="150" [rowHover]="true" [totalRecords]="totalAccounts"
                [loading]="isAccountslistLoading">
                <ng-template pTemplate="caption">
                    <div class="flex flex-wrap justify-content-end gap-2">
                        <p-button severity="success" label="Mark Accounts Inactive" (onClick)="markInactiveSureparkAccounts()" [loading]="isAccountslistLoading" [disabled]="!accounts.length"/>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pResizableColumn pSortableColumn="firstName">
                            Name
                            <p-sortIcon field="firstName"></p-sortIcon>
                        </th>
                        <th>IDs</th>
                        <th pResizableColumn pSortableColumn="groupId">
                            Group
                            <p-sortIcon field="groupId"></p-sortIcon>
                        </th>
                        <th>Start Validity</th>
                        <th>End Validity</th>
                        <th>Status</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-account>
                    <tr>
                        <td class="mpi-text-truncate">{{ account.firstName }} - {{ account.lastName }}</td>
                        <td class="mpi-text-truncate">{{ getIds(account.identifiers) }}</td>
                        <td class="mpi-text-truncate">{{ account.groupId }}</td>
                        <td class="mpi-text-truncate">{{ account.startValidity | date:'MM/dd/yyyy' }}</td>
                        <td class="mpi-text-truncate">{{ account.endValidity | date:'MM/dd/yyyy' }}</td>
                        <td>{{ account.active ? 'Active' : 'Inactive' }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5" class="text-center"><b>No Data Found.</b></td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
